import { render } from "./FfjbFooter.vue?vue&type=template&id=b09d424e&scoped=true"
import script from "./FfjbFooter.vue?vue&type=script&lang=js"
export * from "./FfjbFooter.vue?vue&type=script&lang=js"

import "./FfjbFooter.vue?vue&type=style&index=0&id=b09d424e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b09d424e"]])

export default __exports__